<template lang="pug">
.send-message-select-modal
  b-modal(ref="modal" size="lg" no-close-on-backdrop no-close-on-esc @ok="add" @cancel="cancel")
    template(v-slot:modal-title)
      span 宛先を選択してください。
      span.font-strong-color 必ず施設のスマートフォンを選択してください。

    b-card-group.send-message-select-modal-card-group(deck)
      b-card.align-self-start(no-body)
        span.send-message-header(slot="header") グループ名
        b-list-group.select-area(flush)
          template(v-for="group in value")
            b-list-group-item.resident(href="#" @click="selectGroup(group)" :class="getGroupSelectedClass(group.id)") {{ group.name }}

      b-card.align-self-start(no-body)
        span.send-message-header(slot="header") {{ groupName }}
        b-list-group.family-area(flush)
          b-form-radio-group(v-model="selectedMember")
            b-list-group-item(v-for="member in viewGroup.members" :key="viewGroup.id + '-' + member.memberId" v-if="member.senderType == 0")
              b-form-radio(:value="member") {{ member.memberName }}

    div(slot="modal-footer" slot-scope="{ ok, cancel }")
      button.btn.modal-ok-btn(v-if="_checked" type="button" @click="ok()") OK
      button.btn.modal-ok-btn.disable(v-else type="button" disabled) OK
      button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { OtherUserGroupTypeGroup } from "@/commons/services/OtherUserGroupTypeMembers";

/**
 * メッセージ送信宛先選択モーダル
 */
@Component
export default class TransferOnlineReservationSelectModal extends Vue {
  /** 選択対象の利用者リスト、利用者には家族が紐づいている */
  @Prop({ required: true })
  value!: Array<OtherUserGroupTypeGroup>;

  /** 選択された宛先候補のグループ名 */
  groupName: string = "";
  /** 選択されたグループID */
  selectedGroupId: number = 0;
  /** 宛先候補のグループ */
  viewGroup: any = {};
  /** 選択されたメンバー */
  selectedMember: any = {};

  get _checked(): boolean {
    if (this.selectedMember.memberId != undefined) {
      return true;
    } else {
      return false;
    }
  }

  public getGroupSelectedClass(id: number): any {
    return {
      "selected-group": this.selectedGroupId === id ? true : false
    };
  }

  /**
   * 宛先選択イベント処理
   */
  public selectGroup(group: any): void {
    this.groupName = group.name;
    this.viewGroup = {
      id: group.id,
      name: group.name,
      members: group.members
    };

    this.selectedGroupId = group.id;

    return;
  }

  /**
   * モーダル表示
   *
   * - 初期表示は未選択の状態で表示する
   */
  public show(): void {
    this.viewGroup = {};
    this.groupName = "　";
    this.selectedMember = {};
    this.selectedGroupId = 0;

    const modal: any = this.$refs.modal;
    if (modal) {
      modal.show();
    }

    return;
  }

  /**
   * OKボタン押下イベント
   *
   * - 親コンポーネントに入力情報を通知する
   */
  public add(): void {
    this.$emit("add", this.selectedMember);

    return;
  }

  /**
   * キャンセルボタン押下イベント
   *
   * - 入力した内容を全て破棄する
   * - 親コンポーネントに通知する
   */
  public cancel(): void {
    this.$emit("cancel");

    return;
  }
}
</script>

<style lang="scss">
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

.font-strong-color {
  color: $font-strong-color;
}

.send-message-select-modal-card-group {
  .select-area {
    position: relative;
    max-height: calc(100vh - 300px);
    overflow-y: auto;
  }
  .family-area {
    position: relative;
    max-height: calc(100vh - 300px);
    overflow-y: auto;
  }
  .send-message-header {
    @include bold-font(16px);
  }
  .selected-group {
    background-color: $btn-selected !important;
    color: $btn-font-selected !important;
  }
  .list-group-item.resident.list-group-item-action {
    &:hover {
      background-color: $list-hover;
    }
    &:focus {
      background-color: $list-selected;
    }
  }
}
</style>
